define('views/pages/organization/settings/index',['require','jquery','mediator','views/base/form','text!templates/pages/organization/settings/index.ejs','views/demo-dialog'],function(require) {
    'use strict';

    var $ = require('jquery'),
        mediator = require('mediator'),
        FormView = require('views/base/form'),
        template = require('text!templates/pages/organization/settings/index.ejs'),
        DemoDialog = require('views/demo-dialog');

    // require('select2');

    var OrganizationSettingsView = FormView.extend({
        autoRender: true,
        template: template,
        region: 'organization-settings-tab',
        listen: {
            'afterLoad model': 'render',
            'activate model': 'onActivate'
        },
        save: function(){
            var _this = this, message = '';

            if (DemoDialog.isDemo()) { this.render(); return DemoDialog.show(); }

            if(this.model.get('Name').length === 0){
                message = 'Введите название организации';
            }

            if(!message){
                this.model.set('id', this.model.get('ID'));
                this.model.save().complete(function(response) {
                    if (response.message) {
                        _this.errorMessages.push(response.message);
                    }
                    _this.render();
                });
            } else {
                _this.errorMessages.push(message);
                _this.render();
            }
        },
        render: function() {
            FormView.prototype.render.apply(this, arguments);

            var _this = this;
            var $sel = this.$('select');
            $sel.on('change', function(){
                _this.model.set('ID_CurrencyView', parseInt($(arguments[0].currentTarget).val()));
            });
        },
        onActivate: function() {
            mediator.setBreadcrumb(['organization'], 'Настройки');
            this.model.load(true);
        }
    });

    return OrganizationSettingsView;
});

